import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../ListView/listView.scss";
import translations from "../../translations/resources/en-GB.json";
import { MapKeys, MAP_STATUS } from "../../store/common/constants";
import { setInternalToolMapSearchText, setInternalToolMapSortText, setIsSortClicked, setSearchClicked, } from "../../store/reducers/venuesSlice";
import Loader from "../../components/loader";
import ListView from "../../pages/ListView/ListView";
import { searchVenueFromList } from "../../api/venuesList";
var IndoorMapPage = function () {
    var dispatch = useDispatch();
    var mapStatusFilterList = {
        all: translations.data["venonboard.listView.filter.showAll"],
        checkIn: MAP_STATUS[MapKeys.CHECKED_IN].LABEL,
        checkOut: MAP_STATUS[MapKeys.CHECKED_OUT].LABEL,
    };
    var venuesList = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.venues.list; });
    var venuesListArray = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.venues.initialVenuesList; });
    var isSearchClicked = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.venues.isSearchClicked; });
    var isSortClicked = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.venues.isSortClicked; });
    var internalToolMapSearchText = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.venues.internalToolMapSearchText; });
    var internalToolMapSortText = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.venues.internalToolMapSortText; });
    var isNoMap = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.app.isNoMap; });
    var _a = useState(venuesListArray), venueState = _a[0], setVenueState = _a[1];
    var _b = useState(true), isLoader = _b[0], setIsLoader = _b[1];
    var _c = useState(mapStatusFilterList.all), filterValue = _c[0], setFilterValue = _c[1];
    var _d = useState(false), isVenueListUpdated = _d[0], setIsVenueListUpdated = _d[1];
    useEffect(function () {
        if ((isSearchClicked &&
            (internalToolMapSearchText || internalToolMapSearchText === "")) ||
            (isSortClicked && internalToolMapSortText)) {
            dispatch(searchVenueFromList(internalToolMapSearchText, internalToolMapSortText, filterValue, setVenueState));
        }
    }, [
        isSearchClicked,
        internalToolMapSearchText,
        internalToolMapSortText,
        isSortClicked,
    ]);
    useEffect(function () {
        setIsLoader(false);
        setVenueState(venuesList);
        // if search text is not blank then initially set it blank
        internalToolMapSearchText !== "" &&
            dispatch(setInternalToolMapSearchText({
                isSearchClicked: false,
                internalToolMapSearchText: "",
            }));
        // if sort text is not modified then initially set it modified
        internalToolMapSortText !== "modified" &&
            dispatch(setInternalToolMapSortText({
                internalToolMapSortText: "modified",
                isSortClicked: false,
            }));
        return function () {
            // when unmounting search and sort click needs to be false so that it will not go in searching block on initial load of tab
            setIsSortClicked(false);
            setSearchClicked(false);
        };
    }, []);
    useEffect(function () {
        if (isNoMap) {
            setVenueState(venuesListArray);
        }
    }, [isNoMap]);
    useEffect(function () {
        setVenueState(venuesListArray);
    }, [JSON.stringify(venuesListArray)]);
    var handleFilterChange = function (value) {
        dispatch(searchVenueFromList(internalToolMapSearchText, internalToolMapSortText, value, setVenueState));
        setFilterValue(value);
    };
    return (_jsx(_Fragment, { children: !isLoader ? (_jsx(ListView, { venueList: venueState, onSearchChange: function (searchText) {
                return dispatch(setInternalToolMapSearchText({
                    isSearchClicked: true,
                    internalToolMapSearchText: searchText,
                }));
            }, onSortChange: function (sortText) {
                return dispatch(setInternalToolMapSortText({
                    internalToolMapSortText: sortText,
                    isSortClicked: true,
                }));
            }, searchText: internalToolMapSearchText, sortText: internalToolMapSortText, onFilterChange: handleFilterChange, disableFilter: !isVenueListUpdated, filterValue: filterValue, setIsVenueListUpdated: setIsVenueListUpdated })) : (_jsx(Loader, {})) }));
};
export default IndoorMapPage;
